module.exports = __webpack_public_path__ + "img/sugardaddy.cb94cc3a.svg";